import { render, staticRenderFns } from "./TopfansContact.vue?vue&type=template&id=fe239574&scoped=true&"
import script from "./TopfansContact.vue?vue&type=script&lang=js&"
export * from "./TopfansContact.vue?vue&type=script&lang=js&"
import style0 from "./TopfansContact.vue?vue&type=style&index=0&id=fe239574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe239574",
  null
  
)

export default component.exports